import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/documento-becario';
const headers = { 'Content-Type': 'multipart/form-data' };
const files = ['archivo'];
/**
 * GET Documentos Becarios
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosBecarios = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Documento Becario
 * @param {object} params
 * @returns {Promise<object|null>}
 */
export const getDocumentoBecario = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Documentos Becarios params
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosBecariosParams = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Documento Becario
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDocumentoBecario = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Documento Becario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentoBecario = async (id, values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(`${baseURI}/${id}`, formattedValues);
    // const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Documento Becario
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteDocumentoBecario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Documentos Becario Status
 * @param {object} values
 * @returns {Promise<{}>}
 */
export const putDocumentosBecarioStatus = async (values) => {
  try {
    const response = await API.put('catalogos/actualizar-documentos-becario-status', values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
